<template>
  <div class="programari">
    <HeaderComponent />

    <main class="content">
      <section class="programari-info">
        <h1>Programări</h1>

        <p class="intro-text">Te așteptăm să faci primul pas spre sprijinul de care ai nevoie!</p>
        <p class="intro-text">Pentru a face o programare, sună-ne la <a href="tel:0720823740" class="phone-link">0720823740</a>. Vei discuta cu unul dintre membrii echipei noastre, care îți va oferi toate informațiile necesare.</p>
        <p class="intro-text">Cabinetul nostru funcționează exclusiv pe bază de programări, asigurând astfel o planificare eficientă și atenție dedicată fiecărui client.</p>

        <div class="program-section">
          <h3>Orar:</h3>
          <ul class="program-list">
            <li><span class="day">Luni - Vineri:</span> 9:00 - 19:00</li>
            <li><span class="day">Sâmbătă:</span> în funcție de programări</li>
            <li><span class="day">Duminică:</span> Închis</li>
          </ul>
        </div>

        <div class="address-section">
          <h3>Adresa cabinetului:</h3>
          <p class="intro-text">Strada Vasile Goldiș nr. 2A, bl. S1, sc. B, ap. 3, interfon 03, Alba Iulia 510209</p>
          <div class="map-container">
            <div class="clickable-map-wrapper" @click="openGoogleMaps">
              <iframe
                  class="google-map"
                  :src="mapSrc"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade">
              </iframe>
              <div class="map-overlay">
                <div class="map-click-message">Click pentru a deschide în Google Maps</div>
              </div>
            </div>
          </div>
        </div>

        <div class="policy-section" v-if="showPolicy">
          <h3>Politica de programări:</h3>
          <div >
            <p>Programările se fac în baza disponibilității, iar fiecare ședință este rezervată în funcție de preferințele tale și orarul nostru.</p>
            <p>În cazul în care nu poți ajunge la întâlnire, te rugăm să ne anunți, pentru a putea realoca intervalul.</p>
            <p>Dacă ai o situație de urgență și ai nevoie de o programare prioritară, contactează-ne și vom încerca să găsim o soluție cât mai rapidă.</p>
          </div>
        </div>
        <button class="policy-btn" @click="togglePolicy">
          {{ showPolicy ? 'Ascunde' : 'Politica de programări' }}
        </button>

      </section>
    </main>
    <FooterComponent />
  </div>
</template>

<script>
  import HeaderComponent from "../components/HeaderComponent.vue";
  import FooterComponent from "../components/FooterComponent.vue";

  export default {
    name: 'Contact',
    components: {FooterComponent, HeaderComponent},
    data() {
      return {
        showPolicy: false,
        coordinates: {
          lat: 46.068178,
          lng: 23.563204
        },
        mapSrc:
          `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d365.6487405368423!2d23.563002610491655!3d46.068309659502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x474ea7dbe30f80d9%3A0xf1d6b27d71a31159!2sCabinet%20Psihologie%20Presecan%20-%20Alba%20Iulia!5e1!3m2!1sen!2sro!4v1744885690456!5m2!1sen!2sro`
      }
    },
    computed: {

    },
    methods: {
      togglePolicy() {
        this.showPolicy = !this.showPolicy;
      },
      openGoogleMaps() {
        window.open(`https://www.google.com/maps?q=${this.coordinates.lat},${this.coordinates.lng}&z=17`, '_blank');
      }
    }
  }
</script>

<style lang="scss">
  $primary-color: #263f7a;
  $hover-color: #1a2b53;
  $white: white;
  $off-white: #f5f5f5;

  @media only screen and (min-width: 0px) {
    .programari {
      margin-top: 80px;
      font-weight: 200;
      font-size: 22px;

      .content {
        max-width: 1000px;
        margin: 40px auto;
        padding: 0 20px;
      }

      .programari-info {
        text-align: left;

        h1 {
          font-size: 38px;
          margin-bottom: 20px;
          color: $primary-color;
          text-align: center;
        }

        .intro-text {
          font-size: 22px;
          margin-bottom: 15px;
          font-weight: 400;
        }

        p {
          font-size: 22px;
          line-height: 1.6;
          margin-bottom: 15px;
          text-align: left;
        }

        h3 {
          font-size: 26px;
          margin: 30px 0 15px;
          color: $primary-color;
          text-align: left;
        }

        .phone-link {
          color: $primary-color;
          font-weight: 500;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        .program-list {
          list-style: none;
          padding: 0;
          margin: 0 0 20px;
          text-align: left;

          li {
            margin-bottom: 10px;
            font-size: 22px;
            text-align: left;
          }

          .day {
            font-weight: 1000;
          }
        }

        .address-section {
          margin-bottom: 30px;
          text-align: left;
        }

        .map-container {
          margin-top: 15px;
          height: 300px;
          border-radius: 4px;
          overflow: hidden;
        }

        .clickable-map-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          cursor: pointer;

          &:hover .map-overlay {
            opacity: 1;
          }
        }

        .google-map {
          width: 100%;
          height: 100%;
          border: none;
        }

        .map-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .map-click-message {
          background-color: rgba(255, 255, 255, 0.9);
          color: $primary-color;
          padding: 10px 16px;
          border-radius: 4px;
          font-weight: 500;
          font-size: 16px;
        }

        .policy-section {
          text-align: left;
        }

        .policy-btn {
          display: inline-block;
          margin-top: 10px;
          margin-bottom: 20px;
          padding: 10px 20px;
          background-color: $primary-color;
          color: $white;
          border: none;
          border-radius: 4px;
          font-size: 22px;
          cursor: pointer;
          transition: background-color 0.3s;

          &:hover {
            background-color: $hover-color;
          }
        }
      }
    }
  }
</style>